const ResultIndexByQuestion = data => {
  const series = value =>
    value.map(v => ({
      marker: {
        radius: 8
      },
      lineWidth: 1,
      name: v.name,
      data: v.data
    }));

  return {
    credits: {
      enabled: false
    },
    chart: {
      height: 600
    },
    title: {
      text: null
    },
    colors: ["#FFD46A", "#60B3DD"],
    series: series(data),
    legend: {
      align: "right",
      verticalAlign: "top"
    },
    yAxis: {
      title: null
    },
    xAxis: {
      labels: {
        enabled: false
      }
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          padding: 0,
          allowOverlap: true,
          overflow: "none",
          crop: false,
          style: {
            fontSize: "8px"
          },
          format: `{point.y:.1f}`
        }
      }
    },
    tooltip: {
      backgroundColor: "#ffffff",
      outside: true
    }
  };
};

export default ResultIndexByQuestion;



// WEBPACK FOOTER //
// ./src/models/ResultIndexByQuestion.js